export enum AllWeaponTypes {
	Enemy = -1,
	Unknown = -1,
	None = 0, // empty skill/passive

	// primary
	Bow,
	Wand,
	Boomerang,
	Spear,
	Cannon,

	// secondary
	TeslaCoil,
	AcidBottles,
	RatParade,
	NikolaScope,
	ConeDogThorns,
	Bees,
	Lute,
	DarkStormyNight,
	FireFairies,
	PhoenixBombs,

	// skills
	ElfRangerSkill,
	BarbarianSkill,
	DogSkill,
	SolaraSkill,
	RadarSkill,

	// passives
	ElfRangerPassive,
	BarbarianPassive,
	SolaraPassive,
	RadarPassive,

	// system
	DamageOverTime,
	WorldHazard,
	Pet,
}

export enum PrimaryWeaponType {
	None = AllWeaponTypes.None,
	Bow = AllWeaponTypes.Bow,
	Wand = AllWeaponTypes.Wand,
	Boomerang = AllWeaponTypes.Boomerang,
	Spear = AllWeaponTypes.Spear,
	Cannon = AllWeaponTypes.Cannon
}


export const WeaponConfig: {
	[k in AllWeaponTypes]: {
		dbName: string,
		name: string,
		description: string,
		icon: string,
		endRunIcon: string,
		primary?: {
			assetName: string,
			evolveDescription1: string,
			evolveDescription2: string,
			evolveDescription3: string,
		},
	}
} = {
	[AllWeaponTypes.Enemy]: {
		dbName: "enemy",
		name: "Enemy",
		description: "",
		icon: "",
		endRunIcon: ""
	},
	[AllWeaponTypes.Unknown]: {
		dbName: "unknown",
		name: "Unknown",
		description: "",
		icon: "",
		endRunIcon: ""
	},
	[AllWeaponTypes.None]: {
		dbName: "none",
		name: "None",
		description: "",
		icon: "",
		endRunIcon: ""
	},
	[AllWeaponTypes.WorldHazard]: {
		dbName: "worldHazard",
		name: "World Hazard",
		description: "",
		icon: "",
		endRunIcon: ""
	},
	[AllWeaponTypes.DamageOverTime]: {
		dbName: "damageOverTime",
		name: "Damage-over-time",
		description: "",
		icon: "perk-ailment-potency-bonus", //@TODO real icon
		endRunIcon: 'icon-damage-over-time'
	},
	[AllWeaponTypes.Bow]: {
		dbName: "bow",
		name: "Bow",
		description: "Charge up and release powerful arrows that pierce through targets and deal incredible damage.",
		icon: "primary-bow",
		endRunIcon: 'upgrade-expert-marksmanship',
		primary: {
			assetName: "weapon-bow",
			evolveDescription1: "Longbow: Crashing power and fierce forces let you stagger and blow away your foes. ",
			evolveDescription2: "Assassin's Arch: High speed and piercing let this bow carve lines of death across the field.",
			evolveDescription3: "Storm Breaker: One arrow becomes a dozen as you charge this bow beyond normal limits."
		},
	},
	[AllWeaponTypes.Wand]: {
		dbName: "wand",
		name: "Wand",
		description: "Rapidly fire magical blasts to pelt enemies, then reload and do it again.",
		icon: "primary-wand",
		endRunIcon: "upgrade-quickchange-artist",
		primary: {
			assetName: "weapon-wand",
			evolveDescription1: "Markswitch: Precision & accuracy will grant you stacking bonuses and unleash elemental powers.",
			evolveDescription2: "Tactical Strike: 3-round burst fire will make quick work of enemies, stacking damage-over-time and debuffs along the way.",
			evolveDescription3: "Arcane Rain: Double down on ultra-fast firing with massive magical reserves. Unleash dozens of shots before reloading."
		},
	},
	[AllWeaponTypes.Boomerang]: {
		dbName: "boomerang",
		name: "Boomerang",
		description: "Toss boomerangs that sweep through enemies dealing damage, then return to you dealing damage again.",
		icon: "primary-boomerang",
		endRunIcon: "upgrade-hard-hitting-rangs",
		primary: {
			assetName: "weapon-boomerang",
			evolveDescription1: "Chakram: Rapidly throw 'rangs that alternate directions, travel fast, and inflict elemental ailments.",
			evolveDescription2: "Outback Boomerang: Throw 'rangs that hover in the area, dealing damage continuously until they return.",
			evolveDescription3: "Coming soon!",
		},
	},
	[AllWeaponTypes.Spear]: {
		dbName: "spear",
		name: "Spear",
		description: "Thrust to attack with the spear, dealing powerful damage to all enemies in a line.",
		icon: "primary-spear",
		endRunIcon: "upgrade-better-grips",
		primary: {
			assetName: "weapon-spear",
			evolveDescription1: "Naginata: Sweeping Strikes and clever movement lead you to victory. ",
			evolveDescription2: "Grand Pike: Pure force and area control dominate the battlefield.",
			evolveDescription3: "Holy Spear: Precision and elemental effects let this spear provide judgement to the evil forces.",
		},
	},
	[AllWeaponTypes.Cannon]: {
		dbName: "cannon",
		name: "Cannon",
		description: "This back-mounted weapon fires in an arc and deals devastating damage wherever its explosive projectile lands ",
		icon: "primary-cannon",
		endRunIcon: "icon-cannon",
		primary: {
			assetName: "weapon-cannon",
			evolveDescription1: "Todo",
			evolveDescription2: "Todo",
			evolveDescription3: "Todo",
		},
	},
	[AllWeaponTypes.TeslaCoil]: {
		dbName: "teslaCoil",
		name: "Tesla Coil",
		description: "",
		icon: "secondary-tesla-coil",
		endRunIcon: "upgrade-unlock-tesla-coil"
	},
	[AllWeaponTypes.DarkStormyNight]: {
		dbName: "darkStormyNight",
		name: "Dark Stormy Night",
		description: "",
		icon: "secondary-dark-stormy-night",
		endRunIcon: "upgrade-unlock-dark-stormy-night"
	},
	[AllWeaponTypes.AcidBottles]: {
		dbName: "poisonBottles",
		name: "Acid Bottles",
		description: "",
		icon: "secondary-acid-bottle",
		endRunIcon: "upgrade-unlock-poison-bottles"
	},
	[AllWeaponTypes.RatParade]: {
		dbName: "ratParade",
		name: "Rat Parade",
		description: "",
		icon: "secondary-rat-parade",
		endRunIcon: "upgrade-unlock-rat-parade"
	},
	[AllWeaponTypes.NikolaScope]: {
		dbName: "nikolaScope",
		name: "Nikola's Scope",
		description: "",
		icon: "secondary-nikolas-scope",
		endRunIcon: "upgrade-unlock-nikolas-scope"
	},
	[AllWeaponTypes.ConeDogThorns]: {
		dbName: "coneDogThorns",
		name: "Thorns",
		description: "",
		icon: "secondary-cone-dog-thorns",
		endRunIcon: "upgrade-thorny",
	},
	[AllWeaponTypes.Bees]: {
		dbName: "bees",
		name: "Bees",
		description: "",
		icon: "secondary-bees",
		endRunIcon: "upgrade-unlock-bees"
	},
	[AllWeaponTypes.Lute]: {
		dbName: "lute",
		name: "Lute",
		description: "",
		icon: "secondary-lute",
		endRunIcon: "upgrade-unlock-lute"
	},
	[AllWeaponTypes.FireFairies]: {
		dbName: "fireFairies",
		name: "Fire Fairies",
		description: "",
		icon: "secondary-fire-fairy",
		endRunIcon: "upgrade-unlock-fire-fairy"
	},
	[AllWeaponTypes.PhoenixBombs]: {
		dbName: "phoenixBombs",
		name: "Phoenix Bombs",
		description: "",
		icon: "secondary-phoenix-bombs",
		endRunIcon: "upgrade-unlock-phoenix-bombs"
	},
	[AllWeaponTypes.ElfRangerSkill]: {
		dbName: "rangerTrap",
		name: "Ranger's Trap",
		description: "",
		icon: "skills-thorn-trap",
		endRunIcon: "upgrade-gotta-make-em-bleed",
	},
	[AllWeaponTypes.BarbarianSkill]: {
		dbName: "barbarianRoll",
		name: "Fearsome Roar",
		description: "",
		icon: "skills-tumble-roll",
		endRunIcon: "upgrade-fearsome-roar"
	},
	[AllWeaponTypes.DogSkill]: {
		dbName: "chomp",
		name: "Chomp",
		description: "",
		icon: "skills-chomp",
		endRunIcon: "upgrade-chomp-vicious"
	},
	[AllWeaponTypes.SolaraSkill]: {
		dbName: "solaraChange",
		name: "Change Aspect",
		description: "",
		icon: "skills-aspect",
		endRunIcon: "upgrade-eminence-of-equinox"
	},
	[AllWeaponTypes.RadarSkill]: {
		dbName: "radarSkill",
		name: "Shock Pulse",
		description: "",
		icon: "skills-pulse-shock",
		endRunIcon: "upgrade-pickup-sweep",
	},
	[AllWeaponTypes.RadarPassive]: {
		dbName: "radarPassive",
		name: "FieldOp™ Gadget",
		description: "",
		icon: "skills-tracker",
		endRunIcon: "upgrade-high-capacity-battery"
	},
	[AllWeaponTypes.ElfRangerPassive]: {
		dbName: "rangerMark",
		name: "Ranger's Mark",
		description: "",
		icon: "skills-tracker",
		endRunIcon: "upgrade-impatient"
	},
	[AllWeaponTypes.BarbarianPassive]: {
		dbName: "barbarianAura",
		name: "Barbarian Aura",
		description: "",
		icon: "character-barb",
		endRunIcon: "upgrade-intimidating-aura"
	},
	[AllWeaponTypes.SolaraPassive]: {
		dbName: "aspectAttunement",
		name: "Aspect Attunement",
		description: "",
		icon: "skills-aspect",
		endRunIcon: "upgrade-eminence-of-equinox"
	},
	[AllWeaponTypes.Pet]: {
		dbName: "pets",
		name: "Pets",
		description: "",
		icon: "secondary-pets",
		endRunIcon: "upgrade-twos-company"
	},
}

export enum SkillWeaponType {
	NoSkill = AllWeaponTypes.None,
	ElfRangerSkill = AllWeaponTypes.ElfRangerSkill,
	BarbarianSkill = AllWeaponTypes.BarbarianSkill,
	RadarSkill = AllWeaponTypes.RadarSkill
}

export enum SecondaryWeaponType {
	TeslaCoil = AllWeaponTypes.TeslaCoil,
	AcidBottles = AllWeaponTypes.AcidBottles,
	RatParade = AllWeaponTypes.RatParade,
	NikolaScope = AllWeaponTypes.NikolaScope,
	ConeDogThorns = AllWeaponTypes.ConeDogThorns,
	Bees = AllWeaponTypes.Bees,
	Lute = AllWeaponTypes.Lute,
	DarkStormyNight = AllWeaponTypes.DarkStormyNight,
	FireFairies = AllWeaponTypes.FireFairies,
	PhoenixBombs = AllWeaponTypes.PhoenixBombs
}
